module.exports = "/_next/static/images/home-banner.nc-3a53bc32bdac9d74a51a3621f3ebb493.svg";